export const SHOW_NOTICE = Symbol('showNotice');
export const CLOSE_NOTICE = Symbol('closeNotice');
export const CLEAR_NOTICES = Symbol('clearNotices');
